/**
 * Central business configuration for Plenty Rydez.
 * Edit this file only — do NOT hard-code business info anywhere else.
 */
export const BUSINESS = {
  name: "Plenty Rydez",
  tagline: "Luxury Chauffeur & Rental Fleet",
  phone: "929-899-3467",
  phoneTel: "+19298993467",
  email: "concierge@plentyrydez.com",
  address: {
    street: "1818 East New York Ave",
    city: "Brooklyn",
    state: "NY",
    zip: "11207",
    full: "1818 East New York Ave, Brooklyn, NY 11207",
  },
  serviceAreas: ["New York", "New Jersey", "Pennsylvania", "DMV", "Connecticut"],
  social: {
    instagram: "plenty_rydez",
    instagramUrl: "https://instagram.com/plenty_rydez",
  },
  colors: {
    black: "#000000",
    ink: "#0b0b0d",
    gold: "#C9A24B",
    goldSoft: "#E5C77A",
    champagne: "#F5EBD8",
  },
  chauffeur: {
    serviceTypes: [
      "Airport Transfer", "Hourly Chauffeur", "Wedding", "Prom",
      "Concert", "Corporate", "Birthday", "Night Out", "Special Request",
    ],
    vehiclePreferences: [
      "Black Truck", "Cadillac Escalade", "Sprinter Van", "Luxury SUV", "No Preference",
    ],
  },
  intro: {
    // Drop the cinematic MP4 file at /app/frontend/public/plenty-rydez-intro.mp4
    // and the WebM at plenty-rydez-intro.webm. Component auto-detects and plays.
    mp4Src: "/plenty-rydez-intro.mp4",
    webmSrc: "/plenty-rydez-intro.webm",
    fallbackImage: "/plenty-rydez-intro-fallback.jpg",
    durationMs: 12000,   // safety-net dismiss (Sora clip is ~10s + fade)
  },
  // Official brand logo (Chauffeured Black Truck seal). Used across the mobile PWA.
  logo: "/plenty-rydez-logo.webp",
};

export default BUSINESS;
